import { MultiStepStepProps } from 'components/MultiStepFlow/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { MobileInstructions } from './MobileInstructions'
import { DesktopInstructions } from './DesktopInstructions'

export const BrandKitInstructions: React.FC<MultiStepStepProps> = ({ onNext, onBack }) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <MultiStepStepLayout title="Create your Brand Kit" onBack={isMobile ? undefined : onBack} onNext={onNext}>
      <ResponsiveDesign.Mobile>
        <MobileInstructions title="Next, create a Brand Kit to craft some cool content" />
      </ResponsiveDesign.Mobile>
      <ResponsiveDesign.Desktop>
        <DesktopInstructions />
      </ResponsiveDesign.Desktop>
    </MultiStepStepLayout>
  )
}
